import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
	AuthnService,
	ComponentBase,
	DeploymentContext,
	UserService,
	WebAnalyticsService,
} from '@Common';
import { urlIdentifierForCompany } from 'company-finder-common';

@Component({
	selector: 'update',
	templateUrl: './update.component.html',
	styleUrls: ['./update.component.scss'],
	standalone: false,
})
export class UpdateComponent extends ComponentBase implements OnInit {
	public showProgressIndicator = false;

	constructor(
		deploymentContext: DeploymentContext,
		private _authnService: AuthnService,
		private _webAnalyticsService: WebAnalyticsService,
		private _router: Router,
		private userService: UserService
	) {
		super(deploymentContext);
	}

	public async ngOnInit(): Promise<void> {
		// FUTURE - this really should in a route guard
		const companyLists = await this.userService.getCompanyLists();
		if (companyLists?.isCompanyContactFor?.length > 0) {
			const route = `/company/update/${urlIdentifierForCompany(
				companyLists?.isCompanyContactFor[0]
			)}`;
			this._router.navigate([route]);
		} else {
			this._router.navigate(['/']);
		}
	}
}
